import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ComputerIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="computer icon">
      {/* <title>computer icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 16.4169V16.9238C3 18.2646 4.08778 19.3524 5.42854 19.3524H18.5715C19.9122 19.3524 21 18.2646 21 16.9238V16.4169C21 16.1133 20.7538 15.8672 20.4493 15.8672H3.54973C3.24616 15.8672 3 16.1133 3 16.4169Z"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.668 15.8668V7.66076C19.668 5.99698 18.3195 4.64844 16.6567 4.64844H7.34045C5.67666 4.64844 4.32812 5.99698 4.32812 7.66076V15.8668"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3242 7.67578H12.6737"
        stroke={props.fill || "currentColor" || "#202123"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ComputerIcon;
